import {useEffect, useRef, useState} from 'react'
import {Box, Flex, Image, Text, Progress} from '@chakra-ui/react'
import Roadmap1 from '@pages/RoadmapPage/components/Roadmap1'
import RoadmapFull from '@pages/RoadmapPage/components/RoadmapFull'
import mapRequest from '@apis/map'
import {useDispatch, useSelector} from 'react-redux'
import {getMapStatus, updateStatusMap} from '@redux/map/mapSlice'
import {LOCAL_STORAGE, PATH, STATUS_CODE} from '@utils/Const'
import Loading from '@components/Loading'
import {useNavigate} from 'react-router-dom'
import {isLoggedIn} from '@utils'
import Logo from '@assets/svgs/roadmap/logo.svg'
import MicIcon from '@assets/svgs/roadmap/mic.svg'
import Background from '@assets/images/map.png'

const RoadmapPage = () => {
  const [indexMap, setIndexMap] = useState(0)
  const [data, setData] = useState<any>()
  const dataAnswers = useRef<any>([])
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {isFinishRoadMap, isLoading} = useSelector((state: any) => state.map)
  const retrievedToken = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)
  const userID = localStorage.getItem(LOCAL_STORAGE.USER_ID)

  useEffect(() => {
    // @ts-ignore
    dispatch(getMapStatus())
  }, [])

  useEffect(() => {
    getDataQuestion()
  }, [])

  const getDataQuestion = async () => {
    let res = await mapRequest.getMapQuestions()
    if (res?.data?.status === STATUS_CODE.SUCCESS) {
      setData(res?.data?.data)
    }
  }

  useEffect(() => {
    if (indexMap === data?.length) {
      finishQuestion()
    }
  }, [indexMap])

  const finishQuestion = async () => {
    let res = await mapRequest.submitMapQuestions({
      answers: dataAnswers?.current,
    })
    if (res?.data?.status === STATUS_CODE.SUCCESS) {
      await new Promise(resolve => setTimeout(resolve, 2000))
      // @ts-ignore
      dispatch(updateStatusMap(true))
    }
  }

  async function init() {
    if (!(!userID && !retrievedToken)) {
      // @ts-ignore
      initTracking(userID)
      return
    }
    // @ts-ignore
    dispatch(appInit())
  }

  const handleLogout = () => {
    localStorage.clear()
    init()
    navigate(PATH.HOME, {replace: true})
    window.location.reload()
  }

  const handleNext = (radio: any) => {
    const updateRadio = {
      ...radio,
      type: radio?.type,
      answer: Array.isArray(radio?.answer)
        ? radio?.answer.join(',')
        : radio?.answer,
    }

    dataAnswers?.current?.push(updateRadio)
    const isStudent = ['HOC_SINH_CAP_3', 'HOC_SINH_CAP_2'].includes(
      dataAnswers?.current[0]?.answer,
    )
    const isUnused = Array.isArray(radio?.answer)
      ? radio?.answer.includes('CHUA_SU_DUNG')
      : radio?.answer === 'CHUA_SU_DUNG'
    let stepsForward = 1 // Default step forward

    if (indexMap === 5) {
      if (isUnused) {
        stepsForward = isStudent ? 2 : 3
      }
    } else if (indexMap === 6) {
      stepsForward = isStudent ? 1 : 2
    }

    setIndexMap(indexMap + stepsForward)
  }

  const handlePrevious = () => {
    const isStudent = ['HOC_SINH_CAP_3', 'HOC_SINH_CAP_2'].includes(
      dataAnswers?.current[0]?.answer,
    )
    const previousAnswer = dataAnswers?.current[5]?.answer
    const isUnused = previousAnswer === 'CHUA_SU_DUNG'
    let stepsBack = 1 // Default step back

    if (indexMap === 8) {
      if (!isStudent) {
        stepsBack = isUnused ? 3 : 2
      }
    } else if (indexMap === 7 && isUnused) {
      stepsBack = 2
    }

    setIndexMap(indexMap - stepsBack)
    dataAnswers?.current?.pop()
  }

  return (
    <Box h={'100%'} position={'relative'}>
      {isLoading && <Loading />}
      {!isFinishRoadMap ? (
        <Flex
          p={{base: '16px', md: '32px'}}
          flex={1}
          flexDirection={'column'}
          h={'100%'}
          minH={'100dvh'}
          bgImage={{
            base: 'none',
            md: `linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)), url(${Background})`,
          }}
          bgSize={'cover'}>
          <Flex alignItems={'center'} justifyContent={'space-between'}>
            <Flex w={'170px'} alignItems="center" cursor="pointer">
              <Image src={MicIcon} alt="IELTS Coach Logo" mr={2} />
              <Image src={Logo} alt="IELTS Coach Logo" />
            </Flex>
            <Flex
              flex={1}
              justifyContent={'center'}
              display={{base: 'none', md: 'flex'}}
              px={8}>
              <Progress
                w={'100%'}
                maxWidth={'900px'}
                hasStripe
                value={data ? (indexMap / data.length) * 100 : 0}
                sx={{
                  borderRadius: '12px',
                  '& > div': {
                    background:
                      'linear-gradient(90deg, #1890FF 0%, #74CAFF 100%)',
                    borderRadius: '12px',
                  },
                }}
              />
            </Flex>
            <Flex gap={1} fontSize={'16px'} fontWeight={500} zIndex={1000}>
              {isLoggedIn() ? (
                <Text cursor={'pointer'} onClick={handleLogout}>
                  Đăng xuất
                </Text>
              ) : (
                <>
                  <Text cursor={'pointer'} onClick={() => navigate(PATH.LOGIN)}>
                    Đăng nhập
                  </Text>
                  /
                  <Text
                    cursor={'pointer'}
                    onClick={() => navigate(PATH.REGISTER)}>
                    Đăng ký
                  </Text>
                </>
              )}
            </Flex>
          </Flex>
          <Box pt={{base: '30px', md: '80px'}}>
            <Roadmap1
              data={data?.[indexMap]}
              indexMap={indexMap}
              showLoading={indexMap === data?.length}
              onNext={handleNext}
              onPrevious={handlePrevious}
            />
          </Box>
        </Flex>
      ) : (
        <RoadmapFull />
      )}
    </Box>
  )
}

export default RoadmapPage
